/*       */

import Immutable from 'app/utils/immutable/Immutable';
import { getStr } from 'app/utils/utils';

/**
 * Returns the reducer to handle the standard DataTable actions.
 *
 * @param startActionType the start action type
 * @param endActionType the end action type
 */

const dataTableReducer = (startActionType, endActionType, keepDataAtStart = () => false) => (
    state = { records: [], count: 0, isLoading: false, isDownloading: false },
    action
) => {
    const { type, payload, error, meta = {} } = action;

    switch (type) {
        case startActionType: {
            if (meta.download) {
                return Immutable({ ...state, isDownloading: true });
            }
            let next = { ...state, isLoading: true };
            if (!keepDataAtStart({ state, type, payload, error, meta })) {
                next = { ...next, records: [], count: 0 };
            }
            return Immutable(next);
        }

        case endActionType: {
            if (error) {
                return Immutable({ ...state, records: [], isLoading: false });
            }
            if (meta.download) {
                return Immutable({ ...state, isDownloading: false });
            }
            const { records = [], count = 0 } = payload || {};
            return Immutable({ ...state, ...(meta || {}), isLoading: false, records, count });
        }

        default:
            return state;
    }
};

/**
 * Returns the reducer to handle the standard DataTable actions.
 *
 * @param startActionType the start action type
 * @param endActionType the end action type
 */
const loadDataReducer = (startActionType, endActionType, keepDataAtStart = () => false) => (state = { data: null, isLoading: false }, action) => {
    const { type, payload, error, meta } = action;

    switch (type) {
        case startActionType:
            const next = { ...state, isLoading: true, failure: null };
            if (meta && meta.mutate) {
                return next;
            }
            if (!keepDataAtStart({ state, type, payload, error, meta })) {
                next.data = null;
            }
            return Immutable(next);

        case endActionType:
            if (error) {
                if (meta && meta.mutate) {
                    return Immutable({ ...state, error, failure: payload, meta, isLoading: false });
                }
                return Immutable({ ...state, error, failure: payload, data: null, meta, isLoading: false });
            }
            return Immutable({ ...state, isLoading: false, data: payload });

        default:
            return state;
    }
};

/**
 * Compare new data Id and old data Id
 */
const compareId = ({ state, meta }) => getStr(state, 'data.id') === getStr(meta, 'id');

/**
 * @return true
 */
const keepDataAtStart = () => true;

/**
 * Wraps loadDataReducer to also handle subscription updates.
 * This allows updating sidebar details from WebSocket subscriptions without triggering loading states.
 *
 * @param startActionType the start action type
 * @param endActionType the end action type
 * @param subscriptionActionType the subscription update action type
 * @param keepDataFn optional function to determine if data should be kept at start
 */
const loadDataReducerWithSubscription = (startActionType, endActionType, subscriptionActionType, keepDataFn = () => false) => {
    const baseReducer = loadDataReducer(startActionType, endActionType, keepDataFn);
    return (state, action) => {
        if (action.type === subscriptionActionType) {
            return Immutable({ ...state, data: action.payload });
        }
        return baseReducer(state, action);
    };
};

export { dataTableReducer, loadDataReducer, loadDataReducerWithSubscription, compareId, keepDataAtStart };
